import React, { memo } from "react";
import { Handle, Position } from "reactflow";

interface CourseGraphNodeData {
  title: string;
  status: "locked" | "available" | "in_progress" | "completed";
  highlighted: boolean;
  dimmed: boolean;
}

const statusStyles: Record<string, string> = {
  completed: "border-correct bg-correct/5",
  in_progress: "border-primary bg-primary/5",
  available: "border-border bg-background",
  locked: "border-border bg-muted/60 opacity-50",
};

const CourseGraphNode: React.FC<{ data: CourseGraphNodeData }> = ({ data }) => {
  const base = statusStyles[data.status] ?? statusStyles.locked;
  const highlight = data.highlighted
    ? "ring-2 ring-primary/40 shadow-md scale-105"
    : "";
  const dim = data.dimmed ? "opacity-30" : "";

  return (
    <div
      className={`rounded-xl border-2 px-4 py-3 min-w-[140px] max-w-[200px] text-center transition-all duration-200 ${base} ${highlight} ${dim}`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-border !w-2 !h-2 !border-0"
      />
      <p className="text-sm font-medium text-foreground leading-snug line-clamp-2">
        {data.title}
      </p>
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-border !w-2 !h-2 !border-0"
      />
    </div>
  );
};

export default memo(CourseGraphNode);
